import React from 'react'

import {noop} from 'es-toolkit'

import cn from '../../libs/class-names'

import checkedItem from '../../assets/icons/checked.svg'

import CheckboxField from '../checkbox-field/checkbox-field'
import Icon from '../icon'

export interface Props {
  classNames?: string[]
  children: React.ReactNode
  selected?: boolean
  multiple?: boolean
  variant?: 'base' | 'headline'
  onClick?: React.MouseEventHandler
}

const SelectMenuItem = React.forwardRef(
  (
    {
      classNames,
      children,
      selected = false,
      multiple = false,
      variant = 'base',
      onClick = noop,
    }: Props,
    ref: React.ForwardedRef<HTMLButtonElement>
  ) => {
    const handleClick = (event: React.MouseEvent) => {
      event.preventDefault()
      onClick(event)
    }

    if (variant === 'headline') {
      return (
        <div className={cn('SelectMenuItem', {[`variant-${variant}`]: !!variant}, classNames)}>
          <span className="SelectMenuItem__label">{children}</span>
        </div>
      )
    }

    return (
      <button
        ref={ref}
        type="button"
        className={cn('SelectMenuItem', {selected, [`variant-${variant}`]: !!variant}, classNames)}
        onClick={handleClick}
      >
        <span className="SelectMenuItem__label">
          {multiple && (
            <span className="SelectMenuItem__checkbox">
              <CheckboxField checked={selected} />
            </span>
          )}
          {children}
        </span>
        {selected && !multiple && (
          <span className="SelectMenuItem__selected">
            <Icon source={checkedItem} />
          </span>
        )}
      </button>
    )
  }
)

SelectMenuItem.displayName = 'SelectMenuItem'

export default SelectMenuItem
